import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatabaseServerOrPathFragmentGql: DocumentNode = gql`
fragment DatabaseServerOrPathFragment on Database {
  __typename
  name
  ... on DatabaseServer {
    hostName
    port
  }
  ... on CloudFile {
    requestUrl
    fileId
    provider
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
`;
